import gql from 'graphql-tag';

const SIGNUP = gql`
  mutation signUp($data: SignUpInput!) {
    signUp(data: $data) {
      data
      message
    }
  }
`;

const SIGNIN = gql`
  mutation signIn($data: SignInInput!) {
    signIn(data: $data) {
      token
    }
  }
`;

const SIGNOUT = gql`
  mutation signOut {
    signOut
  }
`;

const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
    }
  }
`;

const RESET_PASSWORD_VALIDATE = gql`
  mutation resetPasswordValidation($token: String!) {
    resetPasswordForm(token: $token) {
      message
    }
  }
`;

const RESET_PASSWORD = gql`
  mutation resetPassword($data: ResetPasswordInput!) {
    resetPassword(data: $data) {
      message
    }
  }
`;

const VERIFY_MAIL = gql`
  mutation verifyMail($token: String!) {
    verifyMail(token: $token) {
      token
    }
  }
`;

const CHANGE_PASSWORD = gql`
  mutation changePassword($data: ChangePasswordInput!) {
    changePassword(data: $data) {
      message
    }
  }
`;

const REFRESH_TOKENS = gql`
  mutation refreshTokens {
    refreshTokens {
      token
    }
  }
`;

export default {
  SIGNUP,
  SIGNIN,
  SIGNOUT,
  FORGOT_PASSWORD,
  RESET_PASSWORD_VALIDATE,
  RESET_PASSWORD,
  VERIFY_MAIL,
  CHANGE_PASSWORD,
  REFRESH_TOKENS,
};
